import {
    SAVE_USERINFO,
    CLEAR_STATE,
} from '../constants/actionType';

// action creators
export const saveUserInfo = (userInfo: any) => {
    return {
        type: SAVE_USERINFO,
        userInfo
    };
};

export const clearState = () => {
    return {
        type: CLEAR_STATE,
    };
}